<script setup lang="ts">
import { mdiMagnify } from "@mdi/js";
import { ListboxFilter, useForwardProps, type ListboxFilterProps } from "reka-ui";
import type { InputHTMLAttributes } from "vue";
import { useDelegatedProps, type ClassProps } from "../../lib/base-props";
import { cn } from "../../lib/utils";
import Icon from "../icon/Icon.vue";

defineOptions({ inheritAttrs: false });

defineSlots<{
	prepend(): void;
	append(): void;
}>();

interface Props
	extends ListboxFilterProps,
		ClassProps,
		/* @vue-ignore */ Omit<InputHTMLAttributes, keyof ListboxFilterProps> {}

const props = defineProps<Props>();
const filter = defineModel<string>();

const delegatedProps = useDelegatedProps(props);
const forwardedProps = useForwardProps(delegatedProps);
</script>

<template>
	<div class="flex h-10 items-center gap-2 border-b px-3">
		<slot name="prepend">
			<Icon :d="mdiMagnify" size="sm" class="shrink-0 opacity-50" />
		</slot>
		<ListboxFilter
			v-bind="{ ...forwardedProps, ...$attrs }"
			v-model="filter"
			autoFocus
			:class="
				cn(
					'placeholder:text-muted-content flex h-10 w-full rounded-md bg-transparent py-3 text-sm outline-none disabled:cursor-not-allowed disabled:opacity-50',
					props.class
				)
			"
		/>
		<slot name="append" />
	</div>
</template>
